import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: "[appNumberOnly]",
  standalone: false,
})
export class NumberOnlyDirective {
  @HostListener("input", ["$event"]) onInputChange(event: InputEvent): void {
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replace(/[^+0-9]/g, "");
    if (input.value !== sanitizedValue) {
      input.value = sanitizedValue;
      input.dispatchEvent(new Event("input"));
    }
  }
}
